import { remove } from '@core/api/baseApi';
import { AssignRadiologistResponse } from '@core/types';

const revokeRadiologistStudyAccess = async (studyInstanceUid: string, userUid: string): Promise<AssignRadiologistResponse> => 
    await remove(`/Studies/${studyInstanceUid}/assign-radiologist/${userUid}`);

export default revokeRadiologistStudyAccess;
